<template>
  <div class="leftformitem">
    <div class="leftformtitle">{{property.name}}<span v-if="property.checked" class="ischeck">*</span></div>
    <div class="leftformbd"><div class="leftforminput">00:00</div></div>
    <i class="el-icon-arrow-down"></i>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>



 